export const JobCostValidation = (formData) => {
    const errors = {};

    if (!formData.vc_CostName || !formData.vc_CostName.trim()) {
        errors.vc_CostName = 'This field is required';
    }
    if (!formData.vc_Description || !formData.vc_Description.trim()) {
        errors.vc_Description = 'This field is required';
    }
    return errors;
};
